'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function TRFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-jpa5t2g4l", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-0vhipzf6h", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-y05v0e1ld" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-y05v0e1ld", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-jpa5t2g4l)" }, /* @__PURE__ */ React.createElement("use", { fill: "#e31d1c", xlinkHref: "#mantine-y05v0e1ld" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M15.873 4.066c1.852.029 4.093 1.147 4.717 2.694 0 0-2.051-1.23-4.415-.709-2.363.522-3.888 2.574-3.95 5.033-.065 2.626 1.581 4.448 3.713 5.013 2.132.564 4.41-.65 4.41-.65-.29.81-1.65 2.701-4.449 2.657-3.491-.055-7.417-2.65-7.307-7.084.107-4.276 3.832-7.009 7.28-6.954zm5.002 4.08l1.555 1.791 2.233-.708-1.397 1.88 2.045 1.82-2.616-.235-1.62 1.875.086-2.536-2.392-.891 2.147-.746z",
        mask: "url(#mantine-0vhipzf6h)",
        transform: "rotate(-1 16.95 11.085)"
      }
    )))
  );
}

export { TRFlag };
//# sourceMappingURL=TR.mjs.map
